import store from '@/store'
import router from '@/router'

export const errorHandler = (error, errorHandling = true) => {
  if (error.response && error.response.data && error.response.data.code === 'two_many_login') {
    store.commit('authent/disconnect')
    return router.push({
      name: 'login', query: { redirect: router.currentRoute.fullPath, error: 'two_many_login' },
    })

  }
  if (error.message === 'disconnect') {
    store.commit('authent/disconnect')
    router.push({
      name: 'login', query: { redirect: router.currentRoute.fullPath }
    })
  } else if (errorHandling) {
    const status = error.response ? error.response.status : null
    switch (status) {
      case 404:
        store.commit('error/resourceNotFound', true)
        break
      default:
        return Promise.reject(error)
    }
  } else {
    if (error.response.data) {
      error.response.data = JSON.stringify(error.response.data).replace(/[{}[\]"]/gi, ' ')
    } else {
      error.response.data = 'Une erreur est survenue'
    }
    return Promise.reject(error)
  }
}
